

export const Images=[
        {
            "id":1,
            "img": require("./help_image_banner_1.jpeg")
        },
        {
            "id":2,
            "img":require("./help_image_banner_2.jpeg")
        }
    ]
